import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';

import { PublicSubscriptionFormComponent } from '../public-subscription-form/public-subscription-form.component';
import {
  PublicSubscriptionDataSourceService,
  PublicSubscriptionForm,
  SubscriptionNumber,
} from '@web/shared/module/shop';
import { Nillable } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';

@Component({
  selector: 'app-public-subscription-edit',
  imports: [
    PublicSubscriptionFormComponent,
    SpinnerFilledComponent,
    AlertsComponent,
  ],
  templateUrl: './public-subscription-edit.component.html',
  styleUrl: './public-subscription-edit.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class PublicSubscriptionEditComponent implements OnInit {
  public readonly number = input.required<SubscriptionNumber>();
  public readonly cancelEvent = output<void>();
  public readonly submitEvent = output<void>();

  protected readonly data = signal<Nillable<PublicSubscriptionForm>>(null);

  /* prettier-ignore */
  private readonly subscriptionDataSource = inject(PublicSubscriptionDataSourceService);

  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public ngOnInit(): void {
    this.subscriptionDataSource
      .fetchFormByNumber(this.number())
      .subscribe((data) => this.data.set(data));
  }

  public handleSubmitClickEvent(data: PublicSubscriptionForm): void {
    this.subscriptionDataSource
      .updateSubscriptionByForm({
        number: this.number(),
        data,
      })
      .subscribe({
        next: () => this.submitEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  public handleCancelClickEvent(): void {
    this.cancelEvent.emit();
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
